module.exports = __webpack_public_path__ + "img/gouwuche.66fbcfea.png";